/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React from 'react';
import { Skeleton } from 'react-skeleton-generator';

export default function ViewApprovedOrderSkeleton() {
    return (
        <Skeleton.SkeletonThemeProvider>
            <div className="flex items-center sticky top-[94px] w-full pt-6 bg-[#FFFFFF] z-[99]">
                <a href="Admin-My-orders-listing-page.html">
                    <img src="/images/Icon-feather-arrow-left-gray.svg" alt="icon" loading="lazy" decoding="async" />
                </a>
                <span className="text-lg font-normal text-[#555259] pl-3.5">
                    Order Details
                </span>
            </div>
            <div className="flex mt-5">
                <div className="w-[70%] mr-5">
                    <div className="flex -mx-1 mt-1 items-center">
                        <div className="w-2/5 px-1">
                            <div>
                                <p className="text-sm font-semibold text-[#777777]"><Skeleton width="125px" height="15px" /></p>
                                <div className="flex items-center">
                                    <p className="text-xs24 font-semibold text-[#090406] pt-0.5">
                                        <Skeleton width="175px" height="31px" />
                                    </p>
                                    <p className="ml-6 p-1 rounded text-xs3 font-normal text-[#FFFFFF]">
                                        <Skeleton width="45px" height="29px" />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sm:py-2 py-1 mt-6 px-3 bg-[#F5F5FA] rounded-lg  flex justify-between items-center lg:flex-nowrap flex-wrap">
                        <div className="mr-2">
                            <p className="text-[#777777] font-semibold text-xs text-center pb-1 pl-4"><Skeleton width="100px" height="10px" /></p>
                            <p className="font-normal sm:text-lg text-sm text-[#090406] text-center"><Skeleton width="135px" height="20px" /></p>
                        </div>
                        <div className="mr-2">
                            <p className="text-[#777777] font-semibold text-xs text-center pb-1 pl-4"><Skeleton width="100px" height="10px" /></p>
                            <p className="font-normal sm:text-lg text-sm text-[#090406] text-center"><Skeleton width="135px" height="20px" /></p>
                        </div>
                        <div className="mr-2">
                            <p className="text-[#777777] font-semibold text-xs text-center pb-1 pl-4"><Skeleton width="100px" height="10px" /></p>
                            <p className="font-normal sm:text-lg text-sm text-[#090406] text-center"><Skeleton width="135px" height="20px" /></p>
                        </div>
                        <div className="mr-2">
                            <p className="text-[#777777] font-semibold text-xs text-center pb-1 pl-4"><Skeleton width="100px" height="10px" /></p>
                            <p className="font-normal sm:text-lg text-sm text-[#090406] text-center"><Skeleton width="135px" height="20px" /></p>
                        </div>
                        <div className="mr-2">
                            <p className="text-[#777777] font-semibold text-xs text-center pb-1 pl-4"><Skeleton width="100px" height="10px" /></p>
                            <p className="font-normal sm:text-lg text-sm text-[#090406] sm:text-center text-start"><Skeleton width="135px" height="20px" /></p>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-[55%]">
                            <p className="text-xs6 text-[#090406] font-semibold my-3"><Skeleton width="135px" height="20px" /></p>
                            <div className="sm:py-2 py-1 px-3 bg-[#F5F5FA] rounded-lg flex justify-between items-center lg:flex-nowrap flex-wrap">
                                <div className="mr-2">
                                    <p className="text-[#777777] font-semibold text-xs pb-1 pl-4"><Skeleton width="100px" height="10px" /></p>
                                    <p className="font-normal sm:text-lg text-sm text-[#090406]"><Skeleton width="135px" height="20px" /></p>
                                </div>
                                <div className="mr-2">
                                    <p className="text-[#777777] font-semibold text-xs pb-1 pl-4"><Skeleton width="100px" height="10px" /></p>
                                    <p className="font-normal sm:text-lg text-sm text-[#090406]"><Skeleton width="135px" height="20px" /></p>
                                </div>
                                <div className="mr-2">
                                    <p className="text-[#777777] font-semibold text-xs pb-1 pl-4"><Skeleton width="100px" height="10px" /></p>
                                    <p className="font-normal sm:text-lg text-sm text-[#090406]"><Skeleton width="135px" height="20px" /></p>
                                </div>
                            </div>
                        </div>
                        <div className="w-[45%] ml-2">
                            <p className="text-xs6 text-[#090406] font-semibold my-3"><Skeleton width="145px" height="20px" /></p>
                            <div className="sm:py-2 py-1 px-3 bg-[#F5F5FA] rounded-lg flex justify-between items-center lg:flex-nowrap flex-wrap">
                                <div className="mr-2">
                                    <p className="text-[#777777] font-semibold text-xs pb-1 pl-4"><Skeleton width="100px" height="10px" /></p>
                                    <p className="font-normal sm:text-lg text-sm text-[#090406]"><Skeleton width="135px" height="20px" /></p>
                                </div>
                                <div className="mr-2">
                                    <p className="text-[#777777] font-semibold text-xs pb-1 pl-4"><Skeleton width="100px" height="10px" /></p>
                                    <p className="font-normal sm:text-lg text-sm text-[#090406]"><Skeleton width="135px" height="20px" /></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="text-xs6 text-[#090406] font-semibold my-1.5"><Skeleton width="135px" height="20px" /></p>
                    <div className="sm:py-2 py-1 mt-2 sm:px-7 px-2.5 bg-[#F5F5FA] rounded-lg  flex justify-between items-center lg:flex-nowrap flex-wrap">
                        <div className="flex">
                            <div className="w-1/2 pr-[300px]">
                                <p className="font-semibold text-[#777777] text-xs pb-1"><Skeleton width="100px" height="10px" /></p>
                                <p className="font-normal text-base text-[#090406]"><Skeleton width="400px" height="42px" /></p>
                            </div>
                            <div className="w-1/2">
                                <p className="font-semibold text-[#777777] text-xs pb-1"><Skeleton width="100px" height="10px" /></p>
                                <p className="font-normal text-base text-[#090406]"><Skeleton width="400px" height="42px" /></p>
                            </div>
                        </div>
                    </div>
                    <ul className="nav nav-pills flex flex-row list-none pl-0 mb-4 mt-5 =" id="pills-tab" role="tablist">
                        <li className="nav-item mr-[70px]" role="presentation">
                            <a href="#pills-home1" className="nav-link block active font-semibold text-xs25 text-[#707070] invoices relative" id="pills-home1-tab" data-bs-toggle="pill" data-bs-target="#pills-home1" role="tab" aria-controls="pills-home1" aria-selected="true">
                                <Skeleton width="145px" height="20px" />
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a href="#pills-profile1" className="nav-link invoices font-semibold text-xs25 text-[#707070] relative block" id="pills-profile1-tab" data-bs-toggle="pill" data-bs-target="#pills-profile1" role="tab" aria-controls="pills-profile1" aria-selected="false">
                                <Skeleton width="145px" height="20px" />
                            </a>
                        </li>
                    </ul>
                    <div className="tab-pane fade show active" id="pills-home1" role="tabpanel" aria-labelledby="pills-home1-tab">
                        <div className="flex lg:flex-row flex-col">
                            <div className="w-full">
                                <div className="rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-2.5 mb-5 pt-4 m-1 relative">
                                    <div className="flex flex-wrap">
                                        <div className="w-full pt-2">
                                            <div className="flex">
                                                <div className="sm:w-1/4 w-[20%]">
                                                    <Skeleton height="160px" />
                                                </div>
                                                <div className="pl-2.5 sm:w-full w-[80%]">
                                                    <div className="flex sm:items-center items-start sm:flex-row flex-col">
                                                        <p className="sm:text-xl text-base font-bold text-[#090406] pr-3 pt-1"><Skeleton width="100px" height="14px" /></p>
                                                        <p className="text-xs font-semibold text-[#FFFFFF] rounded px-1.5 py-1 w-fit sm:mt-0 mt-1"><Skeleton width="100px" height="14px" /></p>
                                                    </div>
                                                    <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1">
                                                        <span><Skeleton width="200px" height="10px" /></span>
                                                        <span className="sm:px-4 px-2">|</span>
                                                        <span><Skeleton width="200px" height="10px" /></span>
                                                    </p>
                                                    <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                                        <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                                            <Skeleton width="200px" height="10px" />
                                                        </div>
                                                        <p className="text-xs3 font-semibold text-[#808285] sm:px-[6px] sm:border-r sm:border-[#707070] sm:pt-0 pt-1">
                                                            <Skeleton width="200px" height="10px" />
                                                        </p>
                                                        <p className="text-xs3 font-semibold text-[#808285] sm:pl-[6px] sm:pt-0 pt-1">
                                                            <Skeleton width="200px" height="10px" />
                                                        </p>
                                                    </div>
                                                    <div className="flex w-full mb-5 mt-4">
                                                        <p className="font-normal text-xs text-[#808285] mt-2.5 w-[48%]"><Skeleton width="350px" height="30px" /></p>
                                                        <Skeleton width="400px" height="50px" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full border-[#CBCBCB] py-3 border-t">
                                        <div className="w-full flex">
                                            <div className="pb-5 min-w-[150px]">
                                                <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                    {' '}
                                                    <Skeleton width="45px" height="10px" />
                                                </p>
                                                <p className="text-base font-semibold text-[#15090E]">
                                                    {' '}
                                                    <Skeleton width="85px" height="15px" />
                                                </p>
                                            </div>
                                            <div className="ml-2.5 pb-5 min-w-[150px]">
                                                <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px] pb-2">
                                                    {' '}
                                                    <Skeleton width="45px" height="10px" />
                                                </p>
                                                <p className="text-base font-semibold text-[#15090E]">
                                                    {' '}
                                                    <Skeleton width="85px" height="15px" />
                                                </p>
                                            </div>
                                            <div className="pb-5 min-w-[150px]">
                                                <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                    {' '}
                                                    <Skeleton width="45px" height="10px" />
                                                </p>
                                                <p className="text-base font-semibold text-[#15090E]">
                                                    {' '}
                                                    <Skeleton width="85px" height="15px" />
                                                </p>
                                            </div>
                                            <div className="pb-5 min-w-[150px]">
                                                <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px] pb-2">
                                                    {' '}
                                                    <Skeleton width="45px" height="10px" />
                                                </p>
                                                <p className="text-base font-semibold text-[#15090E]">
                                                    <Skeleton width="85px" height="15px" />
                                                </p>
                                            </div>
                                            <div className="pb-5 min-w-[150px]">
                                                <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                    {' '}
                                                    <Skeleton width="45px" height="10px" />
                                                </p>
                                                <p className="text-base font-semibold text-[#15090E]">
                                                    {' '}
                                                    <Skeleton width="85px" height="15px" />
                                                </p>
                                            </div>
                                        </div>
                                        <div className="w-full flex">
                                            <div className="pb-5 min-w-[150px]">
                                                <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                    {' '}
                                                    <Skeleton width="45px" height="10px" />
                                                </p>
                                                <p className="text-base font-semibold text-[#15090E]">
                                                    {' '}
                                                    <Skeleton width="85px" height="15px" />
                                                </p>
                                            </div>
                                            <div className="ml-2.5 pb-5 min-w-[150px]">
                                                <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px] pb-2">
                                                    {' '}
                                                    <Skeleton width="45px" height="10px" />
                                                </p>
                                                <p className="text-base font-semibold text-[#15090E]">
                                                    {' '}
                                                    <Skeleton width="85px" height="15px" />
                                                </p>
                                            </div>
                                            <div className="pb-5 min-w-[150px]">
                                                <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                    {' '}
                                                    <Skeleton width="45px" height="10px" />
                                                </p>
                                                <p className="text-base font-semibold text-[#15090E]">
                                                    {' '}
                                                    <Skeleton width="85px" height="15px" />
                                                </p>
                                            </div>
                                            <div className="pb-5 min-w-[150px]">
                                                <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                    {' '}
                                                    <Skeleton width="45px" height="10px" />
                                                </p>
                                                <p className="text-base font-semibold text-[#15090E]">
                                                    {' '}
                                                    <Skeleton width="85px" height="15px" />
                                                </p>
                                            </div>
                                            <div className="pb-5 min-w-[150px]">
                                                <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                    {' '}
                                                    <Skeleton width="45px" height="10px" />
                                                </p>
                                                <p className="text-base font-semibold text-[#15090E]">
                                                    {' '}
                                                    <Skeleton width="85px" height="15px" />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!-- progress bar --> */}
                                    <div className="border-t border-[#CBCBCB] py-3 overflow-auto sidebar">
                                        <div className="overflow-auto sidebar">
                                            <Skeleton width="1000px" height="90px" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tab-pane fade show active" id="pills-home1" role="tabpanel" aria-labelledby="pills-home1-tab">
                        <div className="flex lg:flex-row flex-col">
                            <div className="w-full">
                                <div className="w-full h-[700px] overflow-auto overflow-x-hidden custom-scrollbar">
                                    <div className="rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-2.5 mb-5 pt-4 m-1 relative">
                                        <div className="flex flex-wrap">
                                            <div className="w-full pt-2">
                                                <div className="flex">
                                                    <div className="sm:w-1/4 w-[20%]">
                                                        <Skeleton height="160px" />
                                                    </div>
                                                    <div className="pl-2.5 sm:w-full w-[80%]">
                                                        <div className="flex sm:items-center items-start sm:flex-row flex-col">
                                                            <p className="sm:text-xl text-base font-bold text-[#090406] pr-3 pt-1"><Skeleton width="100px" height="14px" /></p>
                                                            <p className="text-xs font-semibold text-[#FFFFFF] rounded px-1.5 py-1 w-fit sm:mt-0 mt-1"><Skeleton width="100px" height="14px" /></p>
                                                        </div>
                                                        <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1">
                                                            <span><Skeleton width="200px" height="10px" /></span>
                                                            <span className="sm:px-4 px-2">|</span>
                                                            <span><Skeleton width="200px" height="10px" /></span>
                                                        </p>
                                                        <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                                            <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                                                <Skeleton width="200px" height="10px" />
                                                            </div>
                                                            <p className="text-xs3 font-semibold text-[#808285] sm:px-[6px] sm:border-r sm:border-[#707070] sm:pt-0 pt-1">
                                                                <Skeleton width="200px" height="10px" />
                                                            </p>
                                                            <p className="text-xs3 font-semibold text-[#808285] sm:pl-[6px] sm:pt-0 pt-1">
                                                                <Skeleton width="200px" height="10px" />
                                                            </p>
                                                        </div>
                                                        <div className="flex w-full mb-5 mt-4">
                                                            <p className="font-normal text-xs text-[#808285] mt-2.5 w-[48%]"><Skeleton width="350px" height="30px" /></p>
                                                            <Skeleton width="400px" height="50px" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w-full border-[#CBCBCB] py-3 border-t">
                                            <div className="w-full flex">
                                                <div className="pb-5 min-w-[150px]">
                                                    <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                        {' '}
                                                        <Skeleton width="45px" height="10px" />
                                                    </p>
                                                    <p className="text-base font-semibold text-[#15090E]">
                                                        {' '}
                                                        <Skeleton width="85px" height="15px" />
                                                    </p>
                                                </div>
                                                <div className="ml-2.5 pb-5 min-w-[150px]">
                                                    <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px] pb-2">
                                                        {' '}
                                                        <Skeleton width="45px" height="10px" />
                                                    </p>
                                                    <p className="text-base font-semibold text-[#15090E]">
                                                        {' '}
                                                        <Skeleton width="85px" height="15px" />
                                                    </p>
                                                </div>
                                                <div className="pb-5 min-w-[150px]">
                                                    <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                        {' '}
                                                        <Skeleton width="45px" height="10px" />
                                                    </p>
                                                    <p className="text-base font-semibold text-[#15090E]">
                                                        {' '}
                                                        <Skeleton width="85px" height="15px" />
                                                    </p>
                                                </div>
                                                <div className="pb-5 min-w-[150px]">
                                                    <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px] pb-2">
                                                        {' '}
                                                        <Skeleton width="45px" height="10px" />
                                                    </p>
                                                    <p className="text-base font-semibold text-[#15090E]">
                                                        <Skeleton width="85px" height="15px" />
                                                    </p>
                                                </div>
                                                <div className="pb-5 min-w-[150px]">
                                                    <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                        {' '}
                                                        <Skeleton width="45px" height="10px" />
                                                    </p>
                                                    <p className="text-base font-semibold text-[#15090E]">
                                                        {' '}
                                                        <Skeleton width="85px" height="15px" />
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="w-full flex">
                                                <div className="pb-5 min-w-[150px]">
                                                    <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                        {' '}
                                                        <Skeleton width="45px" height="10px" />
                                                    </p>
                                                    <p className="text-base font-semibold text-[#15090E]">
                                                        {' '}
                                                        <Skeleton width="85px" height="15px" />
                                                    </p>
                                                </div>
                                                <div className="ml-2.5 pb-5 min-w-[150px]">
                                                    <p className="text-xs3 font-semibold text-[#808285] text-start mr-[17px] pb-2">
                                                        {' '}
                                                        <Skeleton width="45px" height="10px" />
                                                    </p>
                                                    <p className="text-base font-semibold text-[#15090E]">
                                                        {' '}
                                                        <Skeleton width="85px" height="15px" />
                                                    </p>
                                                </div>
                                                <div className="pb-5 min-w-[150px]">
                                                    <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                        {' '}
                                                        <Skeleton width="45px" height="10px" />
                                                    </p>
                                                    <p className="text-base font-semibold text-[#15090E]">
                                                        {' '}
                                                        <Skeleton width="85px" height="15px" />
                                                    </p>
                                                </div>
                                                <div className="pb-5 min-w-[150px]">
                                                    <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                        {' '}
                                                        <Skeleton width="45px" height="10px" />
                                                    </p>
                                                    <p className="text-base font-semibold text-[#15090E]">
                                                        {' '}
                                                        <Skeleton width="85px" height="15px" />
                                                    </p>
                                                </div>
                                                <div className="pb-5 min-w-[150px]">
                                                    <p className="text-xs3 font-semibold text-[#808285] pb-2">
                                                        {' '}
                                                        <Skeleton width="45px" height="10px" />
                                                    </p>
                                                    <p className="text-base font-semibold text-[#15090E]">
                                                        {' '}
                                                        <Skeleton width="85px" height="15px" />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!-- progress bar --> */}
                                        <div className="border-t border-[#CBCBCB] py-3 overflow-auto sidebar">
                                            <div className="overflow-auto sidebar">
                                                <Skeleton width="1000px" height="90px" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-[30%]">
                    {/* <!-- assignning ASE --> */}
                    <div className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] h-auto p-3 my-4 assigned1">
                        <p className="font-semibold text-base text-[#090406] assigned"><Skeleton width="105px" height="18px" /></p>
                        <div className="flex mt-3">
                            <Skeleton borderRadius="28px" width="45px" height="35px" />
                            <div className="pl-2">
                                <p className="text-lg font-normal text-[#303030] pb-2"><Skeleton width="145px" height="18px" /></p>
                                <p className="text-xs12 font-semibold text-[#707070]">
                                    <Skeleton width="105px" height="15px" />
                                </p>
                            </div>
                        </div>
                        <div className="flex mt-1.5">
                            <Skeleton borderRadius="28px" width="45px" height="35px" />
                            <div className="pl-2">
                                <p className="text-lg font-normal text-[#303030] pb-2"><Skeleton width="145px" height="18px" /></p>
                                <p className="text-xs12 font-semibold text-[#707070]">
                                    <Skeleton width="105px" height="15px" />
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Revised summary --> */}
                    <div className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
                        <div className="border-b border-[#CBCBCB] pb-2.5 flex justify-between items-start">
                            <div className="">
                                <p className="text-sm font-semibold text-[#090406] pb-2"><Skeleton width="105px" height="18px" /></p>
                                <p className="sm:text-lg text-base font-normal text-[#555259]"><Skeleton width="145px" height="20px" /></p>
                            </div>
                            <p className="font-normal text-xs3 text-[#555259]"><Skeleton width="145px" height="15px" /></p>
                        </div>
                        <div className="pt-1.5">
                            <ul className="nav nav-pills flex list-none pl-0 pb-1.5 border-b border-[#CBCBCB]" id="pills-tab" role="tablist">
                                <li className="nav-item w-1/2 text-center" role="presentation">
                                    <Skeleton width="145px" height="15px" />
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane active fade show" id="pills-home" role="tabpanel" aria-labelledby="pills-propose-tab">
                                    <div className="py-1 border-b border-[#CBCBCB] sm:pr-1 sm:pl-2">
                                        <div className="flex justify-between items-center sm:mt-0 mt-1">
                                            <p className="sm:text-xs18 text-sm text-[#555259] font-normal pb-1"><Skeleton width="145px" height="15px" /></p>
                                            <p className="sm:text-lg text-base font-semibold text-[#555259]"><Skeleton width="145px" height="15px" /></p>
                                        </div>
                                        <div className="flex justify-between items-center sm:mt-0 mt-1">
                                            <p className="sm:text-xs18 text-sm text-[#555259] font-normal pb-1"><Skeleton width="145px" height="15px" /></p>
                                            <p className="sm:text-lg text-base font-semibold text-[#555259]"><Skeleton width="145px" height="15px" /></p>
                                        </div>
                                        <div className="flex justify-between items-center sm:mt-0 mt-1">
                                            <p className="sm:text-xs18 text-sm text-[#555259] font-normal pb-1"><Skeleton width="145px" height="15px" /></p>
                                            <p className="sm:text-lg text-base font-semibold text-[#555259]"><Skeleton width="145px" height="15px" /></p>
                                        </div>
                                        <div className="flex justify-between items-center sm:mt-0 mt-1">
                                            <p className="sm:text-xs18 text-sm text-[#555259] font-normal"><Skeleton width="145px" height="15px" /></p>
                                            <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                                <Skeleton width="145px" height="15px" />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="sm:pr-1 sm:pl-2">
                                        <div className="flex justify-between items-center mt-1.5">
                                            <p className="sm:text-xs18 text-sm text-[#000000] font-normal"><Skeleton width="145px" height="15px" /></p>
                                            <p className="sm:text-xs7 text-base font-semibold text-[#000000]"><Skeleton width="145px" height="15px" /></p>
                                        </div>
                                        <div className="flex justify-between items-center mt-1.5">
                                            <p className="sm:text-sm text-[#555259] font-normal"><Skeleton width="145px" height="15px" /></p>
                                            <p className="sm:text-base font-semibold text-[#000000]"><Skeleton width="145px" height="15px" /></p>
                                        </div>
                                        <div className="flex justify-between items-center mt-1.5">
                                            <p className="sm:text-xs18 text-sm text-[#000000] font-normal"><Skeleton width="145px" height="15px" /></p>
                                            <p className="sm:text-xs7 text-base font-semibold text-[#000000]"><Skeleton width="145px" height="15px" /></p>
                                        </div>
                                    </div>
                                    <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                                        <div className="flex justify-between items-center sm:mt-0 mt-1">
                                            <p className="sm:text-xs18 text-sm text-[#555259] font-normal"><Skeleton width="145px" height="15px" /></p>
                                            <p className="sm:text-lg text-base font-semibold text-[#555259]"><Skeleton width="145px" height="15px" /></p>
                                        </div>
                                    </div>
                                    <div className="sm:pr-1 sm:pl-2 py-1">
                                        <div className="flex justify-between items-center mt-1.5">
                                            <p className="sm:text-xs18 text-sm text-[#000000] font-normal"><Skeleton width="145px" height="15px" /></p>
                                            <p className="sm:text-xs7 text-base font-semibold text-[#000000]"><Skeleton width="145px" height="15px" /></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Distributor comments --> */}
                    <div className="border border-[#CBC7C7 rounded-md bg-[#F5F5FA] h-auto p-3 my-4">
                        <p className="font-semibold text-base text-[#090406]"><Skeleton width="145px" height="18px" /></p>
                        <p className="my-2 font-normal text-sm text-[#555259]"><Skeleton width="400px" height="15px" /></p>
                        <div className="flex items-center">
                            <Skeleton width="195px" height="18px" />
                        </div>
                        <p className="text-[#090406] font-semibold text-base mt-3"><Skeleton width="145px" height="18px" /></p>
                        <p className="font-normal text-sm text-[#555259]" />
                        <p className="text-[#090406] font-semibold text-base mt-6"><Skeleton width="145px" height="18px" /></p>
                        <p>-</p>
                    </div>
                    {/* <!-- Related Documents --> */}
                    <div className="border border-[#CBC7C7 rounded-md bg-[#F5F5FA] h-auto p-3 my-4">
                        <p className="font-semibold text-base text-[#090406] pb-4"><Skeleton width="145px" height="18px" /></p>
                        <div className="flex items-center justify-start">
                            <Skeleton width="400px" height="18px" />
                        </div>
                    </div>
                    {/* <!-- Distributor/customer details --> */}
                    <div className="border border-[#CBC7C7 rounded-md bg-[#F5F5FA] h-auto p-4">
                        <h5 className="text-xs2 font-semibold text-[#000000]"><Skeleton width="185px" height="18px" /></h5>
                        <div className="mt-3 flex items-center">
                            <div>
                                <Skeleton borderRadius="28px" width="45px" height="35px" />
                            </div>
                            <div className="pl-3.5">
                                <p className="text-base font-semibold text-[#303030] pb-2"><Skeleton width="165px" height="18px" /></p>
                                <p className="text-xs13 font-normal text-[#555259]"><Skeleton width="145px" height="18px" /></p>
                            </div>
                        </div>
                        <div className="flex -mx-0.5 mt-2.5">
                            <div className="w-1/2 px-0.5">
                                <p className="text-xs3 font-semibold text-[#808285]"><Skeleton width="95px" height="12px" /></p>
                                <p className="pt-1 text-sm font-normal text-[#090406]"><Skeleton width="125px" height="15px" /></p>
                            </div>
                            <div className="w-1/2 px-0.5">
                                <p className="text-xs3 font-semibold text-[#808285]"><Skeleton width="95px" height="12px" /></p>
                                <p className="pt-1 text-sm font-normal text-[#090406] break-words"><Skeleton width="125px" height="15px" /></p>
                            </div>
                        </div>
                        <p className="font-bold text-xs2 text-[#000000] mt-6"><Skeleton width="125px" height="15px" /></p>
                        <div className="w-3/5 px-0.5 mt-5">
                            <p className="text-xs3 font-semibold text-[#808285]"><Skeleton width="95px" height="12px" /></p>
                            <p className="pt-1 text-sm font-normal text-[#090406] break-words"><Skeleton width="195px" height="15px" /></p>
                        </div>
                        <div className="w-1/2 px-0.5 mt-3">
                            <p className="text-xs3 font-semibold text-[#808285]"><Skeleton width="95px" height="12px" /></p>
                            <p className="pt-1 text-sm font-normal text-[#090406]"><Skeleton width="195px" height="15px" /></p>
                        </div>
                        <div className="w-1/2 px-0.5 mt-3">
                            <p className="text-xs3 font-semibold text-[#808285]"><Skeleton width="95px" height="12px" /></p>
                            <p className="pt-1 text-sm font-normal text-[#090406] break-words"><Skeleton width="195px" height="15px" /></p>
                        </div>
                        <div className="flex -mx-0.5 mt-3">
                            <div className="w-1/2 px-0.5">
                                <p className="text-xs3 font-semibold text-[#808285]"><Skeleton width="55px" height="12px" /></p>
                                <p className="pt-1 text-sm font-normal text-[#090406]"><Skeleton width="165px" height="15px" /></p>
                            </div>
                            <div className="w-1/2 px-0.5">
                                <p className="text-xs3 font-semibold text-[#808285]"><Skeleton width="75px" height="12px" /></p>
                                <p className="pt-1 text-sm font-normal text-[#090406] break-words"><Skeleton width="165px" height="15px" /></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Skeleton.SkeletonThemeProvider>
    );
}
